export default "__VITE_ASSET__atqaWyzh__"